// extracted by mini-css-extract-plugin
module.exports = {"Updated":"TermsAndCondition_Updated__N2-nx"};